export default class LightsOutGameModel {
    public static rooms = {
        Bedroom: {
            visited: false,
            completed: false,
            itemsLeftOn: new Array<string>(),
        },
        Bathroom: {
            visited: false,
            completed: false,
            itemsLeftOn: new Array<string>(),
        },
        Kitchen: {
            visited: false,
            completed: false,
            itemsLeftOn: new Array<string>(),
        },
        LivingRoom: {
            visited: false,
            completed: false,
            itemsLeftOn: new Array<string>(),
        },
    };

    public static round = 1;
    public static roundStartTime = 0;
    public static reset() {
        LightsOutGameModel.rooms.Bedroom.visited = false;
        LightsOutGameModel.rooms.Bedroom.completed = false;

        LightsOutGameModel.rooms.Bathroom.visited = false;
        LightsOutGameModel.rooms.Bathroom.completed = false;

        LightsOutGameModel.rooms.Kitchen.visited = false;
        LightsOutGameModel.rooms.Kitchen.completed = false;

        LightsOutGameModel.rooms.LivingRoom.visited = false;
        LightsOutGameModel.rooms.LivingRoom.completed = false;
    }
}
